import { useAppSelector } from 'app/hooks'
import { StyledFadeInWrapper } from 'components/Layout/CommonLayout/styles'
import { selectedHomeSelector } from 'features/home/selectors'
import HomeLogsContent from './HomeLogsContent'
import EnergyHistoryContent from './EnergyHistoryContent'

function HomeLogs() {
  const currentHome = useAppSelector(selectedHomeSelector.data)

  return (
    <>
      <StyledFadeInWrapper>
        {currentHome && <HomeLogsContent home={currentHome} />}
      </StyledFadeInWrapper>
      
      <StyledFadeInWrapper>
      {currentHome && <EnergyHistoryContent home={currentHome} />}
      </StyledFadeInWrapper>
      </>
  )
}

export default HomeLogs
